import React from 'react';
import { useParams } from 'react-router-dom';

const InventoryDetail = () => {
  const { id } = useParams();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Inventory Detail</h1>
      <div className="card">
        <p className="text-gray-600">Item ID: {id}</p>
        <p className="text-gray-500 mt-2">Inventory detail view coming soon...</p>
      </div>
    </div>
  );
};

export default InventoryDetail;
